import { BlogPageProvider } from "./BlogPageProvider";
import { BlogNavigationTabs, useBlogNavigationContext } from "./blogTabs";
import { BlogFilters } from "./blogFilters";
import { BlogPageCardsWrapper } from "./BlogPageCardsWrapper";
import { BlogPageCards } from "./BlogPageCards";

export const BlogsPage = () => {
  const { state } = useBlogNavigationContext();

  if (state.tab === BlogNavigationTabs.EXPLORE) {
    return (
      <BlogPageProvider>
        <BlogFilters />
        <BlogPageCardsWrapper>
          <BlogPageCards />
        </BlogPageCardsWrapper>
      </BlogPageProvider>
    );
  }
};
